import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full';

// Views
import Dashboard from '@/views/Dashboard';
import IndexPage from '@/views/Index';

// Views - Pages
import Edit from '@/views/pages/Edit';
import Page404 from '@/views/pages/Page404';
import Page500 from '@/views/pages/Page500';
import Login from '@/views/pages/Login';

import { AuthRouter, AuthFilter } from '../amplify'

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/index',
      name: 'ホーム',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'ダッシュボード',
          component: Dashboard
        },
        {
          path: 'index',
          name: 'RedPost 連携定義設定',
          component: IndexPage
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) {
          return c('router-view');
        }
      },
      children: [
        {
          path: 'edit',
          name: 'Edit',
          component: Edit
        },
        {
          path: 'edit/:id',
          name: 'EditById',
          component: Edit
        },
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    },
    AuthRouter
  ]
});

router.beforeEach(AuthFilter);

export default router



// WEBPACK FOOTER //
// ./src/router/index.js